import { render, staticRenderFns } from "./Selfpaywx.vue?vue&type=template&id=2fef0ef5&scoped=true"
import script from "./Selfpaywx.vue?vue&type=script&lang=js"
export * from "./Selfpaywx.vue?vue&type=script&lang=js"
import style0 from "./Selfpaywx.vue?vue&type=style&index=0&id=2fef0ef5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fef0ef5",
  null
  
)

export default component.exports